import React from "react";
import ButtonLoader from "../../../components/loader/ButtonLoader";

const ServiceCompleteModal = ({
  onClose,
  confirmText,
  onConfirm,
  isLoading,
  subText,
  width = "w-96",
}) => {
  return (
    <div className="model" onClick={onClose}>
      <div
        className={`bg-white flex flex-col items-center justify-center drop-shadow-lg rounded-lg w-full max-w-md min-h-40 py-8 px-6 mx-auto relative ${width}`}
        onClick={(e) => e.stopPropagation()}
      >
        <h2
          className={` text-xl font-medium  font-Montserrat mb-1 text-center text-primaryBlack`}
        >
          {confirmText}
        </h2>

        <p className="text-sm font-Proxima text-center font-normal">
          {subText}
        </p>

        <div className="flex justify-end gap-2 pt-3">
          <button
            onClick={onClose}
            type="button"
            className="text-themeBtn flex items-center uppercase font-Proxima text-[15px] justify-center px-6 py-1.5 rounded border border-themeBtn"
          >
            <span>Cancel</span>
          </button>
          <button
            type="submit"
            className={`flex items-center justify-center px-6 py-1.5 rounded font-normal font-Proxima text-[15px] uppercase shadow-[4px_4px_10px_rgba(0,0,0,0.2)] ${
              isLoading
                ? "bg-disableThemeBtn "
                : "border-2 border-themeBtn text-white bg-themeBtn"
            }`}
            disabled={isLoading}
            onClick={onConfirm}
          >
            {isLoading ? (
              <ButtonLoader removeTheme={true} />
            ) : (
              <span>Confirm</span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceCompleteModal;
